import { useLocalizedNavigate } from '../../../hooks/useLocalizedNavigate';
import { Invitation } from '../../../utils/types';
import UserAvatar from '../../common/UserAvatar/UserAvatar';
import { TextField } from '../../common';
import { useTranslation } from '../../../hooks/translations/TranslationProvider';

import './eventRequests.css';

interface EventInvitationsProps {
    invitations: Invitation[];
}

const Eventinvitations = ({ invitations }: EventInvitationsProps) => {
    const navigate = useLocalizedNavigate();
    const { t } = useTranslation();

    const userClickHandler = (userId: string) => {
        navigate(`/users/${userId}`);
    };

    if (invitations.length === 0) {
        return (
            <div className="event-join-requests-wrapper">
                <div className="event-join-request">
                    <TextField>{t('eventDetails.emptyInvitations')}</TextField>
                </div>
            </div>
        );
    }

    return (
        <div className="event-join-requests-wrapper">
            {invitations.map(invitation => (
                <div
                    key={`invitation_${invitation.user.id}`}
                    className="event-join-request"
                >
                    <div className="event-join-request-user">
                        <UserAvatar
                            size="m"
                            onClick={() => userClickHandler(invitation.user.id)}
                            averageRating={invitation.user.averageRating}
                        />
                        <TextField>{invitation.user.username}</TextField>
                        <TextField weight="bold" size="s">
                            {t('common.pending')}
                        </TextField>
                    </div>
                </div>
            ))}
        </div>
    );
};

export default Eventinvitations;
